import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import {FC} from 'react';
import {Physician, Prescription} from './RX';

interface RxTableProps {
    drugs: Prescription[];
    physician: Physician[];
}

export const RxTable: FC<RxTableProps> = ({drugs, physician}) => (
    <>
        <h4>Prescription Records</h4>
        {drugs != null && drugs.length > 0 && (
            <TableContainer component={Paper}>
                <Table style={{minWidth: '100%'}}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Drug Name</TableCell>
                            <TableCell>Possible Diagnoses</TableCell>
                            <TableCell>Dates</TableCell>
                            <TableCell>Flag</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {drugs?.map((r) => {
                            let score: string = 'green';
                            if (r.score > 5) {
                                score = 'red';
                            } else if (r.score > 1) {
                                score = 'yellow';
                            }

                            return (
                                <TableRow key={`${r.drug}${r.cond?.join(',') || ''}`}>
                                    <TableCell>{r.drug}</TableCell>
                                    <TableCell>{r.cond?.join(', ')}</TableCell>
                                    <TableCell>{Array.isArray(r?.date) ? r?.date?.join(', ') : r?.date}</TableCell>
                                    <TableCell>
                                        <FiberManualRecordIcon
                                            style={{
                                                color: score,
                                                fontSize: 36,
                                            }}
                                        />
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        )}

        <h4>Physicians</h4>
        {physician != null && physician.length > 0 && (
            <TableContainer component={Paper}>
                <Table style={{minWidth: '100%'}}>
                    <TableHead>
                        <TableRow>
                            <TableCell>First Name</TableCell>
                            <TableCell>Last Name</TableCell>
                            <TableCell>Address</TableCell>
                            <TableCell>City</TableCell>
                            <TableCell>State</TableCell>
                            <TableCell>Zip</TableCell>
                            <TableCell>Phone</TableCell>
                            <TableCell>Specialty</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {physician?.map((r) => (
                            <TableRow key={`${r.firstName}-${r.lastName}`}>
                                <TableCell>{r.firstName}</TableCell>
                                <TableCell>{r.lastName}</TableCell>
                                <TableCell>{r.address}</TableCell>
                                <TableCell>{r.city}</TableCell>
                                <TableCell>{r.state}</TableCell>
                                <TableCell>{r.zip}</TableCell>
                                <TableCell>{r.phone}</TableCell>
                                <TableCell>
                                    {r.specialty != null && Array.isArray(r.specialty) ? r.specialty.join(', ') : null}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        )}
    </>
);
